'use strict';

 /* eslint-disable no-undef */

function initProductListTracking() {
    // Tracking product grids
    var $productGridSection = $('.product-grid-section');
    if ($productGridSection.length) {
        $productGridSection.each(function() {
            trackProductList($(this).find('.product-tile-wrapper__info'), 'HP > ' + $(this).find('h2.product-grid-section__title').text().replace(/\s+/g, ' ').trim());
        })
    }

    // Tracking products in tabs
    var $tabs = $('.tabs');
    if ($tabs.length) {
        $tabs.each(function() {
            $(this).find('.tabs__panel').each(function() {
                trackProductList($(this).find('.image__container'), 'HP > Carousel > ' + $(this).data('tab-panel-title'));
            })

        })
    }
};

/**
 * Send Ajax request to get datalayer object for a product list
 * @param {} $element
 * @param {*} listArea
 */
function trackProductList($element, listArea) {
    if ($element.length) {
        var products = [];
        $element.each(function() {
            if ($(this).data('product-id') !== null) {
                products.push($(this).data('product-id'));
            }
        });

        var url = Urls.GtmProductListTrackingURL + '?products=' + JSON.stringify(products) + '&listArea=' + listArea;

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                dataLayer.push(data.productListDataLayerObject);
            },
            error: function (e) {
                console.log('Error on GTM', e)
            }
        });
    }
}

module.exports = function () {
    initProductListTracking();
};